import { render } from "./DesktopMenu.vue?vue&type=template&id=22748169"
import script from "./DesktopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopMenu.vue?vue&type=script&lang=js"

import "./DesktopMenu.vue?vue&type=style&index=0&id=22748169&lang=scss"

import exportComponent from "/var/www/frontdash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__